import { useEffect, useState } from "react";
import ICONS from "../../../assets/Icons";

const imageChecker = (imageUrl) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = imageUrl;
  });
};

const BeneCategoryImageChecker = ({ category_url }) => {
  const [imgSrc, setImgSrc] = useState(ICONS?.DEFAULT_CATEGORY);

  useEffect(() => {
    const checkImage = async () => {
      if (category_url) {
        const exists = await imageChecker(category_url);
        if (exists) {
          setImgSrc(category_url);
        } else {
          setImgSrc(ICONS?.DEFAULT_CATEGORY);
        }
      } else {
        setImgSrc(ICONS?.DEFAULT_CATEGORY);
      }
    };

    checkImage();
  }, [category_url]);

  return (
    <img
      src={imgSrc}
      alt="bene"
    />
  );
};

export default BeneCategoryImageChecker;
